import { ReactElement } from 'react';
import { RunOption } from './breakdownTypes';

interface Props {
  runs: RunOption[];
  selectedRunId: string | null;
  onSelectRun: (id: string) => void;
  traverseCount: number;
  selectedTraverse: number;
  onSelectTraverse: (i: number) => void;
  isRunLoading?: boolean;
}

export default function RunTraverseSelector({
  runs,
  selectedRunId,
  onSelectRun,
  traverseCount,
  selectedTraverse,
  onSelectTraverse,
  isRunLoading,
}: Props): ReactElement {
  const selectClass =
    'cr-rounded cr-border cr-border-gray-300 cr-px-3 cr-py-2 cr-text-sm cr-bg-white ' +
    'focus:cr-outline-none focus:cr-ring-2 focus:cr-ring-blue-500';

  return (
    <div className="cr-flex cr-gap-4 cr-items-end cr-mb-6">
      <div className="cr-flex cr-flex-col">
        <label className="cr-text-sm cr-font-medium cr-text-gray-700 cr-mb-1">Run</label>
        <select
          className={selectClass}
          value={selectedRunId ?? ''}
          onChange={(e) => onSelectRun(e.target.value)}
          disabled={runs.length === 0}
        >
          {runs.length === 0 && <option value="">No runs available</option>}
          {runs.map((r) => (
            <option key={r.id} value={r.id}>{r.label}</option>
          ))}
        </select>
      </div>
      <div className="cr-flex cr-flex-col">
        <label className="cr-text-sm cr-font-medium cr-text-gray-700 cr-mb-1">Traverse</label>
        <select
          className={selectClass}
          value={selectedTraverse}
          onChange={(e) => onSelectTraverse(Number(e.target.value))}
          disabled={traverseCount === 0 || isRunLoading}
        >
          {traverseCount === 0 && <option value={0}>{isRunLoading ? 'Loading…' : '—'}</option>}
          {Array.from({ length: traverseCount }, (_, i) => (
            <option key={i} value={i}>Traverse {i + 1}</option>
          ))}
        </select>
      </div>
      {traverseCount > 0 && (
        <div className="cr-text-sm cr-text-gray-500 cr-mb-2">
          {traverseCount} traverse{traverseCount === 1 ? '' : 's'} in this run
        </div>
      )}
    </div>
  );
}
